import angular from 'angular';
import _ from 'lodash';
import './invoice.constants.js';

class DocrepoInvoiceFilterCtrl {
    /*@ngInject*/
    constructor(INVOICE, $filter) {
        this.INVOICE = INVOICE;
        this.$filter = $filter;
    }

    $onInit() {
        let vm = this;
        let defaultCriterias = angular.copy(vm.criterias);

        vm.status = _.map(vm.INVOICE.status, 'id');
        vm.translatedStatus = translatedStatus;

        vm.clearForm = function() {
            clearCriterias();
            vm.searchFunction();
        };

        function clearCriterias() {
            angular.copy(defaultCriterias, vm.criterias);
        }

        /**
         * Utilisé pour le tri des status.
         */
        function translatedStatus(status) {
            return vm.$filter('translate')('invoice.status.' + status.toLowerCase());
        }
    }
}

angular.module('app.docrepo_invoice').component('docrepoInvoiceFilter', {
    templateUrl: require('./filter.html'),
    controller: DocrepoInvoiceFilterCtrl,
    bindings: {
        criterias: '=', // Critères de recherches
        searchFunction: '&' // Fonction de recherche
    }
});
